import { callLnsApi } from 'utils/fetch';

export const fetchVersionsForStory = (
  storyGuid: string
): Promise<{ code: number; data: $Lns.Version[] }> =>
  callLnsApi(`/version/story/${storyGuid}`);

export const createVersion = (
  story: Omit<$Lns.Version, 'story'> & { story?: string }
): Promise<{ code: number; data: $Lns.Version }> =>
  callLnsApi('/version', 'POST', story);

export const updateVersion = (
  version: Omit<$Lns.Version, 'story'> & { story?: string }
): Promise<{ code: number; data: $Lns.Version }> =>
  callLnsApi(`/version/${version.guid}`, 'POST', version);

export const deleteVersion = (
  guid: string
): Promise<{ code: number; data: $Lns.Version; message?: string }> =>
  callLnsApi(`/version/${guid}`, 'DELETE');
